export default "__VITE_ASSET__DZfmxyaY__"